import React from 'react';
import clsx from 'clsx';

/**
 * Loading component
 * Loading spinning svg
 */

type LoadingProps = {
  color?: 'violet' | 'grey' | 'light-grey' | string; // 'violet' | 'grey' | 'light-grey' | string;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  customSize?: number; //"pixcel"
  type?: string; // 'bold'
};
export const Loading = ({
  color = 'light-grey',
  className = '',
  customSize,
  size = 'medium',
  type,
}: LoadingProps) => {
  const colorClasses = () => {
    switch (color) {
      case 'violet':
        return '#4d70eb';
      case 'grey':
        return '#cecece';
      case 'light-grey':
        return '#f2f2f2';
      default:
        return color;
    }
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <svg
        className={clsx([
          'animate-spin transition-all duration-1000',
          type === 'bold' ? 'opacity-100' : 'opacity-60',
          customSize
            ? `w-[${customSize}px] h-[${customSize}px]`
            : size === 'small'
              ? 'h-4 w-4'
              : size === 'medium'
                ? 'h-12 w-12'
                : 'h-20 w-20',
        ])}
        viewBox="0 0 66 66"
        xmlns="https://www.w3.org/2000/svg"
      >
        <circle
          style={{
            strokeDashoffset: 0,
            transformOrigin: 'center',
            stroke: `${colorClasses()}`,
          }}
          strokeDasharray={120}
          strokeDashoffset={0}
          fill="none"
          strokeWidth={type === 'bold' ? 8 : 6}
          strokeLinecap="round"
          cx="33"
          cy="33"
          r={type === 'bold' ? '24' : '30'}
        />
      </svg>
    </div>
  );
};
